<template>
  <span class="flex container p4">
    <div>
      <iinput :name="name" v-model="inputs.payload" :value="inputs.payload" />
      <button
        type="button"
        class="fit xs-font p4 indicate"
        @click="testfun(inputs.payload)"
      >
        {{ state.name }}
      </button>
    </div>
    <div
      v-if="outputs && Object.keys(outputs).length > 0 && debug"
      class="v-scroll container success-border p4 m4"
    >
      <b>Return data</b>
      <div>
        <code v-if="typeof outputs == 'string'">{{ outputs }}</code>
        <state v-else tree="tree" :statedata="outputs" />
      </div>
    </div>
  </span>
</template>

<script>
export default {
  data() {
    return {
      input: this.value,
      inputs: {
        payload: {},
      },
      // setting up to accept configs or saved functions by name
      state: this.$store.state.app.advanced.functions[this.fun],
      outputs: {},
    };
  },
  props: {
    debug: { type: Boolean },
    fun: { type: String },
    name: { type: String },
    size: { type: String },
    value: {
      type: [String, Object, Number, Boolean, Array, Function],
    },
  },
  methods: {
    updatevalue: function (value) {
      this.$set(this, "input", value);
      this.$emit("input", value);
    },
    async testfun(payload) {
      return this.$store
        .dispatch("run", {
          fun: this.fun,
          from: this.name || "function admin",
          payload,
        })
        .then(
          (x) => (this.$set(this, "outputs", x), this.updatevalue(this.outputs))
        );
    },
  },
  mounted() {
    console.log({fun: this.fun});
    const fn = this.$store.state.app.advanced.functions[this.fun]
    Object.keys(fn.inputs).map((i) =>
      this.$set(this.inputs.payload, i, fn.inputs[i].static || fn.inputs[i].type == 'string' ? '' : fn.inputs[i].type == 'number' ? 1 : fn.inputs[i].type)
    );
  },
};
</script>

<style>
</style>